import axios from "axios";
import { Notificar } from "../components/Notificador";
import servicioToken from "./servicioToken";
import Autenticador from "./Autenticador";

axios.defaults.headers.common["Accept"] = "application/json";
axios.defaults.headers.common["Authorization"] =
  "Bearer " + servicioToken.obtenerAccessToken();

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      error.response?.status === 401 &&
      error.response?.headers["www-authenticate"]
    ) {
      let accessToken = servicioToken.obtenerAccessToken();
      if (originalRequest.headers.Authorization === `Bearer ${accessToken}`) {
        accessToken = await Autenticador.obtengaTokenPorRefrescamiento();
      }

      originalRequest.headers.Authorization = `Bearer ${accessToken}`;
      return axios(originalRequest);
    }

    if (error.response?.status === 401) {
      Notificar("error", "Requiere autorización para realizar esta acción.");
    }

    if (error.response?.status === 403) {
      Autenticador.cerrarSesion();
    }

    const errorEsperado =
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500;

    if (!errorEsperado) {
      console.log("Log del error", error);
      Notificar("error", "Ocurrió un error inesperado.");
    }

    return Promise.reject(error);
  }
);

export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
};
